import { axios } from '@/main.js';

const userInfo = JSON.parse(localStorage.getItem('userInfo'));
const geoPOIData = JSON.parse(localStorage.getItem('geoPOIData'));

export const getData = async ({ url, fetchObj }) => {
  let arr = [];
  if (!fetchObj.value.timer) {
    startTimer({ fetchObj });
  }
  try {
    let res = {};
    if (url == 'experimental') {
      res.response = await Promise.all([
        axiosPost('multiUnitDetailsv2'),
        axiosPost('dashboardListener'),
      ]);
    } else {
      res.response = await axiosPost(url);
    }
    let response = res.response;
    if (response.status == 200 && response.data.success) {
      arr = response.data.unitDetails;
      return arr;
    }
  } catch (error) {
    console.log(error);
    return arr;
  }
};
async function axiosPost(url) {
  return await axios.post(`${url}/${userInfo.uid}`, {
    selectedUnits: JSON.parse(localStorage.getItem('allUnits')),
    geoPOIData,
  });
}

function startTimer({ fetchObj }) {
  fetchObj.value.time = fetchObj.value.seconds;
  fetchObj.value.timer = setInterval(() => {
    if (fetchObj.value.time > 0) {
      fetchObj.value.time--;
    } else {
      resetTimer({ fetchObj });
    }
  }, 1000);
}
function resetTimer({ fetchObj }) {
  clearInterval(fetchObj.value.timer);
  if (!fetchObj.value.cancel) {
    fetchObj.value.lap++;
    fetchObj.value.timer = null;
  } else {
    fetchObj.value.time = fetchObj.value.seconds;
  }
}

export const searchAssetName = (objects, searchQuery) => {
  // Convert the search query to lowercase for a case-insensitive search
  const lowercasedQuery = searchQuery.toLowerCase();

  // Filter the array of objects based on the assetName property
  const results = objects.filter((obj) => {
    // Convert assetName to lowercase for case-insensitive comparison
    const lowercasedAssetName = obj.assetName.toLowerCase();

    // Check if the lowercased assetName contains the lowercased search query
    return lowercasedAssetName.includes(lowercasedQuery);
  });

  return results;
};

export const getChart = async ([label, props]) => {
  if (label == 'fuel' || label == 'temp') {
    let chartData;
    let dataSource;
    const { data, dataSchema, v } = await getChartData(
      props.assetId,
      props.assetName,
      props.unitId,
      label == 'fuel' ? 'refuelChart' : 'temperatureChart',
      dataSource,
    );
    dataSource = v;
    if (label == 'temp') {
      dataSource = tempChartOptions(props.assetName);
    }
    chartData = {
      data,
      dataSchema,
      dataSource,
    };
    return chartData;
  }
};
async function getChartData(assetId, assetName, unitId, url, dataSource) {
  let response = await axios.post(
    `${url}/${assetId}/${userInfo.uid}/${unitId}`,
    {
      timeRange: 'daily',
      geoPOIData,
    },
  );
  if (response.status == 200 && response.data.success) {
    const data = response.data.series;
    dataSource = fuelChartOptionsV1(assetName);
    dataSource.datamarker = response.data.datamarker;

    const dataSchema = response.data.dataSchema;
    if (response.data.type == 2) {
      dataSource.chart.palettecolors = 'FF0000,FFD700,0000FF,008000';
      dataSource.yaxis = fuelChartOptionsV2(assetName);
    }
    let v = dataSource;
    return { data, dataSchema, v };
  } else if (response.data.error) {
    console.log(response.data.error);
    return;
  } else {
    console.log(response);
    return;
  }
}

export const displayDetails = async (assetId) => {
  let selectedUnitDetailsData = null;
  let heatmapData = null;
  try {
    let response = await axios.post(
      `singleUnitDetails/${assetId}/${userInfo.uid}`,
      {
        geoPOIData,
      },
    );
    if (response.status == 200 && response.data.success) {
      selectedUnitDetailsData = response.data.unitDetails;
      if (
        (userInfo.streetview == true &&
          selectedUnitDetailsData.status == 'Moving') ||
        (userInfo.streetview == 'true' &&
          selectedUnitDetailsData.status == 'Moving')
      ) {
        selectedUnitDetailsData['permission'] = await streetViewAvailability(
          response.data.unitDetails.lat,
          response.data.unitDetails.lng,
        );
      } else {
        selectedUnitDetailsData['permission'] = 1;
      }
    } else if (response.data.error) {
      console.log(response.data.error);
    } else {
      console.log('something happened', response);
    }
    let heatmapData = await getHeatmap(selectedUnitDetailsData);
    return [selectedUnitDetailsData, heatmapData];
  } catch (error) {
    console.log(error);
    return [selectedUnitDetailsData, heatmapData];
  }
};
async function streetViewAvailability(lat, lng) {
  var streetViewService = new google.maps.StreetViewService();

  return await streetViewService.getPanorama(
    {
      location: new google.maps.LatLng(lat, lng),
      source: google.maps.StreetViewSource.OUTDOOR,
    },
    function (data, status) {
      if (status === google.maps.StreetViewStatus.OK) {
        // OK
        return true;
      } else {
        // error or no results
        return false;
      }
    },
  );
}
async function getHeatmap(selectedUnitDetails) {
  let heatmap = null;
  try {
    let response = await axios.post(
      `web-heatmap/${selectedUnitDetails.unitId}`,
      {},
    );
    if (response.status == 200 && response.data.success) {
      heatmap = response.data.heatmap;
    } else if (response.data.error) {
      console.log(response.data.error);
    } else {
      console.log(response);
    }
    return heatmap;
  } catch (error) {
    console.log(error);
    return heatmap;
  }
}

// just chart object
function tempChartOptions(assetName) {
  return {
    data: null,
    navigator: {
      enabled: 0,
    },
    extensions: {
      customRangeSelector: {
        enabled: 0,
      },
    },
    chart: {
      animation: 0,
      palettecolors: '800080,000000,0000FF,008000',
      multicanvas: false,
      exportEnabled: 1,
      exportFileName: `Temperature Chart -${assetName}`,
    },
    caption: {
      text: `Temperature Chart -${assetName}`,
    },
    datamarker: null,
    yaxis: [
      {
        min: -30,
        min: 100,
        plot: [
          {
            value: 'Temperature_1',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: ' °C',
        },
      },
      {
        min: -30,
        min: 100,
        plot: [
          {
            value: 'Temperature_2',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: ' °C',
        },
      },
      {
        min: -30,
        min: 100,
        plot: [
          {
            value: 'Temperature_3',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: ' °C',
        },
      },
      {
        min: -30,
        min: 100,
        plot: [
          {
            value: 'Temperature_4',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: ' °C',
        },
      },
      {
        min: -30,
        min: 100,
        plot: [
          {
            value: 'Preferred_Temperature',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: ' °C',
        },
      },
      {
        plot: [
          {
            value: 'Odometer',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: '',
        },
      },
      {
        min: 0,
        max: 200,
        plot: [
          {
            value: 'Speed',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: ' kph',
        },
      },
    ],
  };
}
function fuelChartOptionsV1(assetName) {
  return {
    data: null,
    navigator: {
      enabled: 0,
    },
    extensions: {
      customRangeSelector: {
        enabled: 0,
      },
    },
    chart: {
      animation: 0,
      palettecolors: 'FF0000,0000FF,008000',
      multicanvas: false,
      exportEnabled: 1,
      exportFileName: `Fuel Chart - ${assetName}`,
    },
    caption: {
      text: `Fuel Chart - ${assetName}`,
    },
    datamarker: null,
    yaxis: [
      {
        min: 0,
        plot: [
          {
            value: 'Fuel',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: ' litres',
        },
      },
      {
        plot: [
          {
            value: 'Odometer',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: '',
        },
      },
      {
        min: 0,
        max: 200,
        plot: [
          {
            value: 'Speed',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: ' kph',
        },
      },
    ],
  };
}
function fuelChartOptionsV2() {
  return [
    {
      min: 0,
      plot: [
        {
          value: 'Fuel',
          connectnulldata: true,
          type: 'line',
        },
      ],
      format: {
        suffix: ' litres',
      },
    },
    {
      min: 0,
      plot: [
        {
          value: 'Fuel2',
          connectnulldata: true,
          type: 'line',
        },
      ],
      format: {
        suffix: ' litres',
      },
    },
    {
      plot: [
        {
          value: 'Odometer',
          connectnulldata: true,
          type: 'line',
        },
      ],
      format: {
        suffix: '',
      },
    },
    {
      min: 0,
      max: 200,
      plot: [
        {
          value: 'Speed',
          connectnulldata: true,
          type: 'line',
        },
      ],
      format: {
        suffix: ' kph',
      },
    },
  ];
}
